<template>
  <div id="selectReadyReport">
    <div id="buttonBar">
      <button v-bind:style="styles.buttonTabReadyReport"
              v-on:click="showShablon_hideSaved()">
        Готовые отчёты
      </button>
      <button v-bind:style="styles.buttonTabShablonReport"
              v-on:click="hideShablon_showSaved()">
        Мои отчёты
      </button>
    </div>
    <div v-if="show.readyReport.shablonReport" id="shablonReport">
      <div v-on:click="setShosenReport('Готовый отчёт','1-НМ')" id="row">
        <h1 id="header">1-НМ</h1>
        <p id="body">Отчет о начислении и поступлении налогов, сборов, страховых взносов и иных обязательных платежей в бюджетную систему Российской Федерации</p>
      </div>
      <div v-on:click="setShosenReport('Готовый отчёт','1-НОМ')" id="row">
        <h1 id="header">1-НОМ</h1>
        <p id="body">Отчет о поступлении о поступлении налогов, сборов и страховых взносов в бюджетную систему Российской федерации по основным видам экономической деятельности</p>
      </div>
    </div>
    <div v-else id="savedReport">
      <h1>Нету сохранённых отчётов</h1>
    </div> 
  </div>
</template>

<script>
	export default {
  name: 'reportSelect',
  props: ['title', 'nestedregs'],
  data: function() {
    return {
      show: {
        readyReport: {
          shablonReport: true,
          savedReport: false,
        },
        sliceSelection: {
          sliceSelection: false
        }
      },
      styles: {
        buttonTabReadyReport: {
          width: '50%',
          height: '30px',
          marginTop: '10px',
          borderWidth: '1px',
          outline: 'none',
          borderColor: '#e0e0e0',
          borderRadius: '2px 2px 0px 0px',
          fontWeight: 'bold',
          backgroundColor: 'white',
          borderStyle: 'solid solid none solid',
          cursor: 'pointer',
        },
        buttonTabShablonReport: {
          width: '50%',
          height: '30px',
          marginTop: '10px',
          borderWidth: '1px',
          outline: 'none',
          borderColor: '#e0e0e0',
          borderRadius: '2px 2px 0px 0px',
          fontWeight: 'bold',
          backgroundColor: 'white',
          color: '#4d82cb',
          borderStyle: 'none none solid none',
          cursor: 'pointer',
        }
      }
    }
  },
  methods: {
    hideShablon_showSaved() {
      this.show.readyReport.shablonReport = false;
      this.show.readyReport.savedReport = true;
      this.styles.buttonTabReadyReport.borderStyle = 'none none solid none'
      this.styles.buttonTabShablonReport.borderStyle = 'solid solid none solid'
      this.styles.buttonTabReadyReport.color = '#4d82cb'
      this.styles.buttonTabShablonReport.color = 'black'
    },
    showShablon_hideSaved() {
      this.show.readyReport.savedReport = false;
      this.show.readyReport.shablonReport = true;
      this.styles.buttonTabShablonReport.borderStyle = 'none none solid none'
      this.styles.buttonTabReadyReport.borderStyle = 'solid solid none solid'
      this.styles.buttonTabReadyReport.color = 'black'
      this.styles.buttonTabShablonReport.color = '#4d82cb'
    },
    setShosenReport(reportKind, reportName) {
      
    }
  }
}
</script>

<style>
#selectReadyReport {
  position: fixed;
  z-index: 120;

  background-color: white;

  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

  width: 350px;
  height: 230px;

  top: 10%;
  left: 12.5%;

  padding: 0px 10px 0px 10px;
}

#shablonReport{
  background-color: white;
  color: black;

  outline: none;

  border-color: #e0e0e0;
  border-width: 1px;
  border-style: none solid solid solid;

  height: 180px;
  width: 348px;
}

#savedReport {
  background-color: white;
  color: black;

  outline: none;

  border-color: #e0e0e0;
  border-width: 1px;
  border-style: none solid solid solid;

  height: 180px;
  width: 348px;
}

#savedReport h1 {
  color: grey;
  font-size: 16px;
  margin-top: 60px;
  margin-left: 70px;
}
</style>